export interface RgbPinConfig {
  redPin: string;
  greenPin: string;
  bluePin: string;
}

export interface PixelConfig {
  dataPin: string;
  ledCount: number;
}

export const beginnerLedState = {
  rgbPins: null as RgbPinConfig | null,
  rgbBrightnessPercent: 100,
  pixelConfig: null as PixelConfig | null,
  pixelBrightnessPercent: 100,
};

export function resetBeginnerLedCodegenState(): void {
  beginnerLedState.rgbPins = null;
  beginnerLedState.rgbBrightnessPercent = 100;
  beginnerLedState.pixelConfig = null;
  beginnerLedState.pixelBrightnessPercent = 100;
}
